import { Box, Grid, styled, Typography } from '@mui/material';

import theme, { colors } from '../../../../theme';

export const Root = styled(Box)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'start',
    paddingLeft: '24px',
    backgroundColor: colors.black2,
    flexDirection: 'column',
    gap: '10px',
    marginTop: '10px',
    marginBottom: '10px'
});

export const Title = styled(Typography)`
    font: 600 14px 'Inter';
    color: ${colors.white90};
    width: 886px;
    height: 17px;
`;
export const TitleContainer = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    flexDirection: 'row'
});
export const Instructions = styled(Typography)`
    font: 13px/23px 'Inter';
    color: ${colors.white50};
`;

export const AttachmentsContainer = styled(Box)({
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    padding: theme.spacing(1)
});

export const AttachmentsHeader = styled(Typography)({
    fontSize: '14px',
    color: colors.white50,
    marginBottom: theme.spacing(1)
});

export const AttachmentsGrid = styled(Grid)({
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: '8px',
    maxHeight: '150px',
    overflowY: 'auto'
});

export const AttachmentItem = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    padding: '6px 12px',
    backgroundColor: colors.codGray,
    borderRadius: '12px',
    fontSize: '12px',
    gap: '6px',
    color: colors.mainGold,
    cursor: 'pointer',
    '&:hover': {
        backgroundColor: '#3D3F4A'
    }
});

const S = {
    Root,
    Title,
    Instructions,
    AttachmentsContainer,
    AttachmentsHeader,
    AttachmentsGrid,
    AttachmentItem,
    TitleContainer
};

export default S; 
